import { create } from "zustand";

const today = new Date();
const lastThreeMonth = new Date(today);

const useDateRangeStore = create((set) => ({
  periodStartDate: lastThreeMonth.setMonth(today.getMonth() - 3),
  periodEndDate: today,
  mainStartDate: lastThreeMonth.setMonth(today.getMonth() - 3),
  mainEndDate: today,
  setPeriodStartDate: (startDate) => {
    set({ periodStartDate: startDate });
  },
  setPeriodEndDate: (endDate) => {
    set({ periodEndDate: endDate });
  },
  setMainStartDate: (startDate) => {
    set({ mainStartDate: startDate });
  },
  setMainEndDate: (endDate) => {
    set({ mainEndDate: endDate });
  },
}));

export default useDateRangeStore;
